import { all, fork, put, takeEvery } from 'redux-saga/effects';
import ValidatedSD from '../../../models/ValidatedSD';
import callToAPI from '../../../utils/callToAPI';
import * as ApiV2 from '../../api/validatedScannedDocuments';
import * as types from './types';

function* deleteValidatedScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: ApiV2.deleteValidatedSD,
    successResponseCode: 200,
    errorType: types.DELETE_VALIDATED_SCANNED_DOCUMENT_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_VALIDATED_SCANNED_DOCUMENT_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

function* getValidatedScannedDocuments({ payload }) {
  yield callToAPI({
    apiCall: ApiV2.getValidatedSD,
    successResponseCode: 200,
    errorType: types.GET_VALIDATED_SCANNED_DOCUMENTS_ERROR,
    *callback({ data: { data, total } }) {
      yield put({
        type: types.GET_VALIDATED_SCANNED_DOCUMENTS_SUCCESS,
        payload: {
          validatedScannedDocuments: data.map(
            (validatedDN) => new ValidatedSD(validatedDN),
          ),
          total: total,
        },
      });
    },
    payload,
  });
}

function* watcherDeleteValidatedScannedDocument() {
  yield takeEvery(
    types.DELETE_VALIDATED_SCANNED_DOCUMENT_REQUEST,
    deleteValidatedScannedDocument,
  );
}
function* watcherGetValidatedScannedDocuments() {
  yield takeEvery(
    types.GET_VALIDATED_SCANNED_DOCUMENTS_REQUEST,
    getValidatedScannedDocuments,
  );
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetValidatedScannedDocuments),
    fork(watcherDeleteValidatedScannedDocument),
  ]);
}
